// This file is auto-generated by @hey-api/openapi-ts

import type { GetApiV1ChangelogsResponse, GetApiV1ChoreBoardResponse, GetApiV1ChoreInstancesByIdResponse, GetApiV1ChoreInstancesResponse, GetApiV1PerformedChoresByIdResponse, GetApiV1PerformedChoresResponse, PostApiV1ChoreInstancesOneTimeResponse, PostApiV1ChoreInstancesResponse, PostApiV1PerformedChoresResponse, PutApiV1ChoreInstancesByIdResponse } from './types.gen';

const changelogDtoSchemaResponseTransformer = (data: any) => {
    data.createdAt = new Date(data.createdAt);
    return data;
};

export const getApiV1ChangelogsResponseTransformer = async (data: any): Promise<GetApiV1ChangelogsResponse> => {
    data = data.map((item: any) => changelogDtoSchemaResponseTransformer(item));
    return data;
};

const choreTileDtoSchemaResponseTransformer = (data: any) => {
    if (data.dueAt) {
        data.dueAt = new Date(data.dueAt);
    }
    if (data.lastPerformedAt) {
        data.lastPerformedAt = new Date(data.lastPerformedAt);
    }
    return data;
};

export const getApiV1ChoreBoardResponseTransformer = async (data: any): Promise<GetApiV1ChoreBoardResponse> => {
    data = data.map((item: any) => choreTileDtoSchemaResponseTransformer(item));
    return data;
};

const choreInstanceDtoSchemaResponseTransformer = (data: any) => {
    if (data.dueAt) {
        data.dueAt = new Date(data.dueAt);
    }
    return data;
};

export const getApiV1ChoreInstancesResponseTransformer = async (data: any): Promise<GetApiV1ChoreInstancesResponse> => {
    data = data.map((item: any) => choreInstanceDtoSchemaResponseTransformer(item));
    return data;
};

export const postApiV1ChoreInstancesResponseTransformer = async (data: any): Promise<PostApiV1ChoreInstancesResponse> => {
    data = choreInstanceDtoSchemaResponseTransformer(data);
    return data;
};

export const getApiV1ChoreInstancesByIdResponseTransformer = async (data: any): Promise<GetApiV1ChoreInstancesByIdResponse> => {
    data = choreInstanceDtoSchemaResponseTransformer(data);
    return data;
};

export const putApiV1ChoreInstancesByIdResponseTransformer = async (data: any): Promise<PutApiV1ChoreInstancesByIdResponse> => {
    data = choreInstanceDtoSchemaResponseTransformer(data);
    return data;
};

export const postApiV1ChoreInstancesOneTimeResponseTransformer = async (data: any): Promise<PostApiV1ChoreInstancesOneTimeResponse> => {
    data = choreInstanceDtoSchemaResponseTransformer(data);
    return data;
};

const performedChoreDtoSchemaResponseTransformer = (data: any) => {
    data.performedAt = new Date(data.performedAt);
    return data;
};

export const getApiV1PerformedChoresResponseTransformer = async (data: any): Promise<GetApiV1PerformedChoresResponse> => {
    data = data.map((item: any) => performedChoreDtoSchemaResponseTransformer(item));
    return data;
};

const createPerformedChoresResponseDtoSchemaResponseTransformer = (data: any) => {
    data.performedChores = data.performedChores.map((item: any) => performedChoreDtoSchemaResponseTransformer(item));
    return data;
};

export const postApiV1PerformedChoresResponseTransformer = async (data: any): Promise<PostApiV1PerformedChoresResponse> => {
    data = createPerformedChoresResponseDtoSchemaResponseTransformer(data);
    return data;
};

export const getApiV1PerformedChoresByIdResponseTransformer = async (data: any): Promise<GetApiV1PerformedChoresByIdResponse> => {
    data = performedChoreDtoSchemaResponseTransformer(data);
    return data;
};
